import {useContext} from 'react'

import PropTypes from 'prop-types'

import {htmlStringToReactElement} from '@s-ui/js/lib/react'
import Context from '@s-ui/react-context'

import FormVersion from './component.js'

const replacementOptions = {
  strongStart: '<strong>',
  strongEnd: '</strong>'
}

const FormVersionBuilder = ({initialSearch, ...props}) => {
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')
  const {
    SEGUNDA_MANO_CATEGORY1_ID,
    VANS_AND_COMMERCIAL_CATEGORY1_ID,
    AUTOCARAVANS_AND_TRAILERS_CATEGORY1_ID,
    CARS_WITHOUT_LICENSE_CATEGORY1_ID,
    CLASSIC_AND_COMPETITION_CATEGORY1_ID,
    MOTOS_CATEGORY1_ID,
    QUADS_CATEGORY1_ID,
    BUGGIES_CATEGORY1_ID,
    MINIMOTOS_CATEGORY1_ID,
    CLASSICS_CATEGORY1_ID
  } = config.get('search')

  const {categoryId} = initialSearch

  const tooltipInfo = i18n.t('COMMON.VERSION_INFO', replacementOptions)
  const tooltipExample = i18n.t('COMMON.VERSION_EXAMPLE', replacementOptions)

  const VersionTooltipContent = (
    <p className="mt-FormVersion-infoTooltip">
      <span className="mt-FormVersion-infoTooltipText">{htmlStringToReactElement(tooltipInfo)}</span>
      <span className="mt-FormVersion-infoTooltipText">{htmlStringToReactElement(tooltipExample)}</span>
    </p>
  )

  const modelLiteral = i18n.t('COMMON.PLURALS.MODEL', 1)

  const versionLiterals = {
    MAKE_MODEL: {
      label: 'COMMON.MAKE_MODEL',
      placeholder: 'COMMON.MAKE_MODEL'
    },
    MODEL: {
      label: modelLiteral,
      placeholder: modelLiteral
    },
    VERSION: {
      label: 'COMMON.VERSION',
      placeholder: 'COMMON.VERSION_PLACEHOLDER',
      tooltipContent: VersionTooltipContent
    }
  }

  const _getComponentLiterals = () => {
    if (!categoryId) return versionLiterals.VERSION
    switch (categoryId) {
      case VANS_AND_COMMERCIAL_CATEGORY1_ID:
      case AUTOCARAVANS_AND_TRAILERS_CATEGORY1_ID:
      case CLASSIC_AND_COMPETITION_CATEGORY1_ID:
      case CLASSICS_CATEGORY1_ID:
      case MINIMOTOS_CATEGORY1_ID:
        return versionLiterals.MAKE_MODEL
      case CARS_WITHOUT_LICENSE_CATEGORY1_ID:
      case MOTOS_CATEGORY1_ID:
      case QUADS_CATEGORY1_ID:
      case BUGGIES_CATEGORY1_ID:
        return versionLiterals.MODEL
      case SEGUNDA_MANO_CATEGORY1_ID:
      default:
        return versionLiterals.VERSION
    }
  }

  const literalProps = _getComponentLiterals()

  return <FormVersion initialSearch={initialSearch} {...props} {...literalProps} />
}

FormVersionBuilder.displayName = 'FormVersion'

FormVersionBuilder.propTypes = {
  initialSearch: PropTypes.object
}

export default FormVersionBuilder
